import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-collabo-portal-reset-password',
  templateUrl: './collabo-portal-reset-password.component.html',
  styleUrls: [
    './collabo-portal-reset-password.component.css',
    '../style/global.css',
  ],
})
export class CollaboPortalResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnInit {
  constructor(title: Title) {
    super();
    title.setTitle('パスワード再設定');
  }
  ngOnInit(): void { }

  /** ロゴ画像のパス取得. カスタム設定されていればそれを使う */
  get logoImageUrl() {
    const imagePath =
      this.app?.cportalConfig?.logoImagePath ||
      '/assets/collabo-portal/images/logo.svg';
    // パスワードリセットページの場合はドメインが違うため、フルのURLを返す
    return `${this.baseUri}${imagePath}`;
  }

  /** ロゴ画像のパス取得. カスタム設定されていればそれを使う */
  get checkmarkImageUrl() {
    const imagePath =
      this.app?.cportalConfig?.logoImagePath ||
      '/assets/collabo-portal/images/check_small.svg';
    // パスワードリセットページの場合はドメインが違うため、フルのURLを返す
    return `${this.baseUri}${imagePath}`;
  }

  // 登録サポートツール用か否か
  get isDxsales() {
    const app = environment.apps[this.clientId];
    return app.connection === 'CBPT-DxSales';
  }
}
